
export function LegendsRouterGroup() {

    return (
           <div className='mb-3 p-3 bg-light rounded border'>
                <div className='row'>
                  <div className='col-md-4'>
                    <h6 className='fw-bold mb-2'>Métodos HTTP</h6>
                    <div className='d-flex flex-column gap-2 small'>
                      <div className='d-flex align-items-center gap-2'>
                        <span className='badge bg-info'>GET</span>
                        <span>Obter dados</span>
                      </div>
                      <div className='d-flex align-items-center gap-2'>
                        <span className='badge bg-success'>POST</span>
                        <span>Criar dados</span>
                      </div>
                      <div className='d-flex align-items-center gap-2'>
                        <span className='badge bg-warning'>PUT</span>
                        <span>Atualizar dados</span>
                      </div>
                      <div className='d-flex align-items-center gap-2'>
                        <span className='badge bg-danger'>DELETE</span>
                        <span>Deletar dados</span>
                      </div>
                      <div className='d-flex align-items-center gap-2'>
                        <span className='badge bg-secondary'>PATCH</span>
                        <span>Atualização parcial</span>
                      </div>
                    </div>
                  </div>
                  <div className='col-md-4'>
                    <h6 className='fw-bold mb-2'>Tipos de Rotas</h6>
                    <div className='d-flex flex-column gap-2 small'>
                      <div>• <strong>Comum</strong>: Rotas de funcionalidade básica</div>
                      <div>• <strong>Pagamento</strong>: Rotas relacionadas a pagamentos</div>
                      <div>• <strong>Hotel</strong>: Rotas do módulo de hotel</div>
                      <div>• <strong>Moda</strong>: Rotas do módulo de moda</div>
                      <div>• <strong>Alimentos</strong>: Rotas do módulo de alimentos</div>
                    </div>
                  </div>
                  <div className='col-md-4'>
                    <h6 className='fw-bold mb-2'>Status de Seleção</h6>
                    <div className='d-flex flex-column gap-2 small'>
                      <div className='d-flex align-items-center gap-2'>
                        <i className='fas fa-check-circle text-success ms-2'></i>
                        <span>Totalmente selecionado</span>
                      </div>
                      <div className='d-flex align-items-center gap-2'>
                       <i className='fas fa-minus-circle text-warning ms-2'></i>
                        <span>Parcialmente selecionado</span>
                      </div>
                      <div className='d-flex align-items-center gap-2'>
                        <i className='far fa-circle text-muted ms-2'></i>
                        <span>Não selecionado</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
    )
}